import { CardScreen } from "@thekrystalship/krystal";

// The furniture the screens in front of the app share — the shell and the brand — so finding the
// cluster's provider, an unavailable cluster and a boot that failed are one surface.

function AuthShell({ tagline, children }) {
  return (
    <CardScreen
      mark={import.meta.env.BASE_URL + "assets/tks-mark.png"}
      wordmark="The Krystal Ship"
      tagline={tagline}>
      {children}
    </CardScreen>
  );
}

export { AuthShell };
